import { Link } from "react-router-dom";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Button } from "@mui/material";
import { getSubscriptionAlert } from "../utils/userProfile";

export default function SubscriptionAlertBanner({ businessSubscription }) {
  const alert = getSubscriptionAlert(businessSubscription);

  if (!alert) return null;

  const isError = alert.severity === "error";
  const Icon = isError ? ErrorOutlineOutlinedIcon : WarningAmberOutlinedIcon;

  return (
    <div
      className={`app-subscription-alert app-subscription-alert--${alert.severity}`}
      role="status"
    >
      <div className="app-subscription-alert__icon-wrap">
        <Icon className="app-subscription-alert__icon" fontSize="small" />
      </div>
      <div className="app-subscription-alert__content">
        <strong className="app-subscription-alert__title">{alert.title}</strong>
        <p className="app-subscription-alert__message">{alert.message}</p>
      </div>
      <Link to={alert.ctaPath} className="app-subscription-alert__cta-link">
        <Button
          variant={isError ? "contained" : "outlined"}
          size="small"
          className={`app-btn app-subscription-alert__cta${
            isError ? " app-btn--primary" : ""
          }`}
        >
          {alert.cta}
        </Button>
      </Link>
    </div>
  );
}
